<!--<div id="overlay">-->
<!--  <ap-loading *ngIf="startLoader" id="text" class="loader-class" [colorName]="'a-primary'">-->
<!--  </ap-loading>-->
<!--</div>-->
@if (startLoader) {
<div class="loader-overlay">
  <div class="backdrop"></div>
  <ap-loading class="loader" [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
</div>
}
<dst-create-disclosure-actions [isView]="false" (onSaveClick)="save()" [disabled]="false"
  [displayNotification]="showDREMsg" [notifMsg]="DREMsg" (onCancelClick)="clear()">
</dst-create-disclosure-actions>
<div class="form-template-wrapper" [ngClass]="showDREMsg ? 'msg-expanded' : ''">
  <div [formGroup]="form237" class="ap-form-field-my-wrapper">
    <dst-template-header [parentFormGroup]="form237" (formOptionChanged)="onFormOptionChanged($event)"
      (consolGroupChanged)="OnConsolGroupChanged($event)">
    </dst-template-header>
    <dst-template-leid-selector [label]="'Please specify the LEID of the Reporting Entity'" [labelId]="'100'"
      (onSelectedLEChanged)="onTransferorChanged($event)" class="required-field">
    </dst-template-leid-selector>
    <!-- <div class="a-form-error error-leid" *ngIf="transferor === undefined">
      Please specify the LEID for the Reporting Entity
    </div> -->
    <!-- </div> -->
    <div class="entity-details">
      <span>Name as shown on tax return:</span><span class="template-color-blue">{{!transferor ? '' :
        transferor.ENTITY}}</span>
    </div>
    <div class="entity-details">
      <span>Identifying number:</span><span class="template-color-blue">{{!transferor ? '' : (transferor.EIN ?
        transferor.EIN : 'N/A')}}</span>
    </div>
    <table class="statement-section-heading" cellpadding="0" cellspacing="0">
      <tbody>
        <tr>
          <td class="header-text">
            <strong>&nbsp;&nbsp;Part I &nbsp;&nbsp;</strong>
            <strong>Information on the Like-Kind Exchange</strong>
          </td>
        </tr>
      </tbody>
    </table>
    <div formGroupName="partOne" class="section-content ap-form-field-my-wrapper">
      <div>
        <strong>Note:&nbsp;</strong><span>Generally, only real property should be described on line 1 or 2. However, you
          may describe personal
          and/or real property on line 1 or 2 if you are filling this form to report the disposition of property
          exchanged
          in a previously reported related part Like-Kind exchange. If the property described on line 1 or line 2 is
          real
          or personal property located outside the United States, indicate the country.</span>
      </div>
      <ol class="section-content">
        <li>
          <div class="d-flex">
            <div class="col-md-12 pl-0">
              Description of Like-Kind Property Given Up
            </div>
          </div>
          <div class="d-flex justify-content-between row">
            <div class="col-md-12">
              <div class="a-textarea-box a-field-length-validation form-inlines">
                <dst-custom-input class="custom-input-100 p-0" [type]="'textarea'" [label]="''" [maxLength]="250"
                  [value]="DescOfLikeKindPropertyGivenUp"
                  (valChange)="DescOfLikeKindPropertyGivenUp = $event;"></dst-custom-input>

              </div>
              <!-- <div class="a-form-error" *ngIf="DescOfLikeKindPropertyGivenUp === ''">
                Please specify the Description of the Like-Kind Property Given Up
              </div> -->
            </div>
          </div>
        </li>

        <li>
          <div class="d-flex">
            <div class="col-md-12 pl-0">
              Description of Like-Kind Property Received
            </div>
          </div>
          <div class="d-flex justify-content-between row">
            <div class="col-md-12">
              <div class="a-textarea-box a-field-length-validation form-inlines">
                <dst-custom-input class="custom-input-100 p-0" [type]="'textarea'" [label]="''" [maxLength]="250"
                  [value]="DescOfLikeKindPropertyReceived"
                  (valChange)="DescOfLikeKindPropertyReceived = $event;"></dst-custom-input>
              </div>
              <!-- <div class="a-form-error" *ngIf="DescOfLikeKindPropertyReceived === ''">
                Please specify the Description of the Like-Kind Property Received
              </div> -->
            </div>
          </div>
        </li>

        <li>
          <div class="d-flex">
            <div class="col-md-9 pl-0">
              Date Like-Kind property given up was originally acquired
            </div>
            <div class="col-md-3 date-fields pr-0">
              <app-date-picker-with-clear
                [minDate]="beginDate"
                [maxDate]="endDate"
                [datePickerClass]="'a-datepicker-margin'"
                [required]="false"
                (dateChange)="dateChange($event, 1)"
                (datePickerClick)="onDPOpen()"
                (clearClick)="clearDate(1)"
                [(ngModel)]="DateLikeKindPropertyGivenUpAcq"
                [ngModelOptions]="{standalone: true}">
              </app-date-picker-with-clear>
            </div>
          </div>
        </li>

        <li>
          <div class="d-flex">
            <div class="col-md-9 pl-0">
              Date you actually transferred your property to other party
            </div>
            <div class="col-md-3 date-fields pr-0">
              @if (nameChangeChecked) {
<app-date-picker-with-clear
               
                [minDate]="beginDate"
                [maxDate]="endDate"
                [datePickerClass]="'a-datepicker-margin'"
                [required]="false"
                (dateChange)="dateChange($event, 2)"
                (datePickerClick)="onDPOpen()"
                (clearClick)="clearDate(2)"
                [(ngModel)]="DatePropActuallyTransferred"
                [ngModelOptions]="{standalone: true}">
              </app-date-picker-with-clear>
}
            </div>
          </div>
        </li>

        <li>
          <div class="d-flex">
            <div class="col-md-9 pl-0">
              Date Like-Kind property you received was identified by written notice to another party. See instructions
              for 45-day written identification requirement
            </div>
            <div class="col-md-3 date-fields pr-0">
              <app-date-picker-with-clear
                [minDate]="beginDate"
                [maxDate]="endDate"
                [datePickerClass]="'a-datepicker-margin'"
                [required]="false"
                (dateChange)="dateChange($event, 3)"
                (datePickerClick)="onDPOpen()"
                (clearClick)="clearDate(3)"
                [(ngModel)]="DateLikeKindPropRcvdIdentified"
                [ngModelOptions]="{standalone: true}">
              </app-date-picker-with-clear>
            </div>
          </div>
        </li>

        <li class="mt-3">
          <div class="d-flex">
            <div class="col-md-9 pl-0">
              Date you actually received the Like-Kind property from other party
            </div>
            <div class="col-md-3 date-fields pr-0">
              <app-date-picker-with-clear
                [minDate]="beginDate"
                [maxDate]="endDate"
                [datePickerClass]="'a-datepicker-margin'"
                [required]="false"
                (dateChange)="dateChange($event, 4)"
                (datePickerClick)="onDPOpen()"
                (clearClick)="clearDate(4)"
                [(ngModel)]="DatePropertyActuallyReceived"
                [ngModelOptions]="{standalone: true}">
              </app-date-picker-with-clear>
            </div>
          </div>
        </li>

        <li>
          <div class="d-flex">
            <div class="col-md-10 p-0">
              Was the exchange of the property given up or received made with a related party, either directly or
              indirectly (such as through an intermediary?)
            </div>
            <div class="col-md-2">
              <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="$any(true)" [(ngModel)]="ExchangeMadeWithRelatedParty" [ngModelOptions]="{standalone: true}" [name]="'radio-group-1'" (onChange)="check7(true)" [styleClass]="'a-mx-10'" [style]="'margin-left: 20px;'">
                <span>Yes</span>
              </ap-radio>
                  <ap-radio [value]="$any(false)" [(ngModel)]="ExchangeMadeWithRelatedParty" [ngModelOptions]="{standalone: true}" [name]="'radio-group-1'" (onChange)="check7(false)" [styleClass]="'a-mx-10'">
                <span>No</span>
              </ap-radio>
                </ap-radio-group>
            </div>
          </div>
          <div>If yes, complete Part II otherwise proceed to Part III</div>
        </li>

      </ol>
      <div>
        <strong>Note:&nbsp;</strong><span>Do not file this form if a related party sold property into the exchange,
          directly or
          indirectly(such as through an intermediary); that property became your replacement property;and none of the
          exceptions in line 11 applies to the exchange, Instead, report the disposition of the property as if the
          exchange had been a sale. If one of the exceptions on line 11 applies to the exchange, complete Part II</span>
      </div>
    </div>
    <div formGroupName="partTwo" [hidden]="ExchangeMadeWithRelatedParty !== true">
      <table class="statement-section-heading" cellpadding="0" cellspacing="0">
        <tbody>
          <tr>
            <td class="header-text">
              <strong>&nbsp;&nbsp;Part II &nbsp;&nbsp;</strong>
              <strong>Related Party Exchange Information</strong>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="section-content ap-form-field-my-wrapper">
        <ol class="section-content mt-0 mb-0" start="8">
          <li class="related-party">
            <dst-template-leid-selector [label]="'Please specify the LEID of the Related Party'" [labelId]="'100'"
              (onSelectedLEChanged)="onTransfereeChanged($event)" class="required-field">
            </dst-template-leid-selector>

            <div class="entity-details">
              <span>Name of Related Party:</span>
              <span class="template-color-blue">{{!transferee ? '' :
                transferee.ENTITY}}</span>
            </div>

            <div class="entity-details">
              <span>Identifying number:</span>
              <span class="template-color-blue">{{!transferee ? '' :
                (transferee.EIN ? transferee.EIN : 'N/A')}}</span>
            </div>

            <div class="entity-details">
              <span>Relationship to you</span>
              <div>
                <ap-field [title]="''" [fieldId]="'3'" [styleClass]="'label-margin'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="RelationshipToYou" [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="3" />
                </ap-field>
              </div>
            </div>
          </li>
          <br />
          <li>
            <div class="d-flex">
              <div class="col-md-10 pl-0">
                During this tax year (and before the date that is 2 years after the last transfer of property that was
                part of the exchange), did the related party sell or dispose of any part of the Like-Kind property
                received from you (or an intermediary) in the exchange ?
              </div>
              <div class="col-md-2 pr-0">
                <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="$any(true)" [(ngModel)]="RelatedPartySoldPropReceived" [ngModelOptions]="{standalone: true}" [name]="'radio-group-2'" (onChange)="check9(true)" [styleClass]="'a-mx-10'">
                  <span>Yes</span>
                </ap-radio>
                  <ap-radio [value]="$any(false)" [(ngModel)]="RelatedPartySoldPropReceived" [ngModelOptions]="{standalone: true}" [name]="'radio-group-2'" (onChange)="check9(false)" [styleClass]="'a-mx-10'">
                  <span>No</span>
                </ap-radio>
                </ap-radio-group>
              </div>
            </div>
          </li>
          <br />
          <li>
            <div class="d-flex ">
              <div class="col-md-10 pl-0">
                During this tax year (and before the date that is 2 years after the last transfer of property that was
                part of the exchange) did you sell or dispose of any part of the Like-Kind property you received?
              </div>
              <div class="col-md-2 pr-0">
                <ap-radio-group [ariaLabel]="'Select an option'">
                  <ap-radio [value]="$any(true)" [(ngModel)]="YouSoldPropertyReceived" [ngModelOptions]="{standalone: true}" [name]="'radio-group-3'" (onChange)="check10(true)" [styleClass]="'a-mx-10'">
                  <span>Yes</span>
                </ap-radio>
                  <ap-radio [value]="$any(false)" [(ngModel)]="YouSoldPropertyReceived" [ngModelOptions]="{standalone: true}" [name]="'radio-group-3'" (onChange)="check10(false)" [styleClass]="'a-mx-10'">
                  <span>No</span>
                </ap-radio>
                </ap-radio-group>
              </div>
            </div>

            <div class="d-flex">
              <div class="col-md-12 pl-0">
                <br />
                If both lines 9 and 10 are No and this is the year of the exchange, go to Part III. If both lines 9 and
                10 are No and this is not the year of the exchange, stop here. If either line 9 or line 10 is Yes
                complete Part III and report on this year's tax return the deferred gain or (loss) from line 24 unless
                one of the exceptions on line 11 applies.
              </div>
            </div>
          </li>
          <br />
          <li class="related-party">If one of the exceptions below applies to the disposition, check the applicable box
            below (a, b, or c)
            <ol class="inner-list section-content">
              <li class="p-0 mb-3">
                <div class="d-flex">
                  <ap-checkbox [ngModel]="editMode && DisposWasAfterDeathRltdParties ? true : false"
                    [ngModelOptions]="{standalone: true}" (onChange)="check11a()" [styleClass]="'a-mx-10'">
                    <span></span>
                  </ap-checkbox>
                  <div class="pl-2">The disposition was after the death of either of the related parties</div>
                </div>
              </li>

              <li class="p-0 mb-3">
                <div class="d-flex">
                  <ap-checkbox [ngModel]="editMode && DisposWasInvoluntaryConversion ? true : false"
                    [ngModelOptions]="{standalone: true}" [styleClass]="'a-mx-10'" (onChange)="check11b()">
                    <span></span>
                  </ap-checkbox>
                  <div class="pl-2">The disposition was an involuntary conversion, and the threat of conversion occurred
                    after the exchange</div>
                </div>
              </li>

              <li class="p-0">
                <div class="d-flex">
                  <ap-checkbox [ngModel]="editMode && ExchangeDisposNotTaxAvoidance ? true : false"
                    [ngModelOptions]="{standalone: true}" [styleClass]="'a-mx-10'" (onChange)="check11c()">
                    <span></span>
                  </ap-checkbox>

                  <div class="pl-2">
                    You can establish to the satisfaction of the IRS that nether the exchange nor the disposition had
                    tax avoidance as its principal purpose. If this box is checked, specify an explanation
                  </div>
                </div>
                <br />

                <div class="list-content a-textarea-box a-field-length-validation form-inlines">
                  <dst-custom-input class="custom-input-100" style="padding-left: 36px;" [type]="'textarea'"
                    [label]="''" [maxLength]="1000" [value]="PrincipalPrpsRltdPartyExchStmtExplanation"
                    (valChange)="PrincipalPrpsRltdPartyExchStmtExplanation = $event;"></dst-custom-input>
                </div>

              </li>
            </ol>
          </li>
        </ol>

        <!-- <div class="a-form-error" *ngIf="ExchangeDisposNotTaxAvoidance === true && PrincipalPrpsRltdPartyExchStmtExplanation === ''">
          Please specify an explanation
        </div> -->
      </div>
    </div>
    <table class="statement-section-heading" cellpadding="0" cellspacing="0">
      <tbody>
        <tr>
          <td class="header-text">
            <strong>&nbsp;&nbsp;Part III &nbsp;&nbsp;</strong>
            <strong>Realized Gain or (Loss), Recognized Gain, and Basis of Like-Kind Property Received</strong>
          </td>
        </tr>
      </tbody>
    </table>
    <div formGroupName="partThree" class="section-content ap-form-field-my-wrapper">
      <strong>Caution:&nbsp;</strong><span>If you transferred and received (a) more than one group of Like-Kind
        properties or (b) cash or other (not
        like-kind) property, see Reporting of multi-asset exchanges in the instructions.</span><span
        class="Appkit4-icon icon-information-fill" ap-tooltip [tooltipContent]="template1" [direction]="'right'"
        [tooltipId]="'sec8824-multi-asset-info'" ariaDescribedby="sec8824-multi-asset-info"></span>
      <div class="d-flex justify-content-between row">
        <br />
      </div>
      <div class="d-flex">
        <div class="col-md-10 pl-0">Amount of the Gain on Multi-Asset Exchange</div>
        <div>
          <ap-field [title]="''" [fieldId]="'5'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="GainInMultiAssetExchangesStmtGainInMultiAssetExchangeAmount"
              [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="5" />
          </ap-field>
        </div>
      </div>
      <br />
      <div class="d-flex justify-content-between row">
        <div class="col-md-12">
          Include the details of the calculation of realized and recognized gain on multi-asset exchanges in text box
          below
        </div>
      </div>

      <div class="list-content a-textarea-box a-field-length-validation form-inlines">
        <dst-custom-input class="custom-input-100 p-0" [type]="'textarea'" [label]="''" [maxLength]="1000"
          [value]="GainInMultiAssetExchangesStmtGainInMultiAssetExchangeExplanation"
          (valChange)="GainInMultiAssetExchangesStmtGainInMultiAssetExchangeExplanation = $event;"></dst-custom-input>

      </div>
      <!-- <div class="a-form-error" *ngIf="GainInMultiAssetExchangesStmtGainInMultiAssetExchangeAmount !== '' && GainInMultiAssetExchangesStmtGainInMultiAssetExchangeExplanation === ''">
        Please specify the details of the calculation
      </div> -->
      <div>
        <strong>Note:&nbsp;</strong><span>Complete lines 12 through 14 ONLY if you gave up property that was not
          Like-Kind. Otherwise, go to line
          15.</span>
      </div>
      <ol class="section-content part-three-fields" start="12" style="padding-left: 20px;">
        <li>
          <div class="d-flex">
            <div class="col-md-10 pl-0">
              Fair market value (FMV) of other property given up
            </div>
            <div class="col-md-2">
              <ap-field [title]="''" [fieldId]="'7'" [styleClass]="'number-field'" [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="FMVOfOtherPropertyGivenUp"
                  [ngModelOptions]="{standalone: true}" (blur)="onCalculateAll()" [placeholder]="''"  aria-label="7" />
              </ap-field>
            </div>
          </div>
          @if (taxYear === '2023') {
<div class="d-flex mt-2 justify-content-between row">
            <div class="col-md-12">
              a. Description of other property given up
            </div>
          </div>
}
          @if (taxYear === '2023') {
<div class="list-content a-textarea-box a-field-length-validation form-inlines">
            <dst-custom-input class="custom-input-100 p-0" [type]="'textarea'" [label]="''" [maxLength]="1000"
              [value]="DescriptionOfOtherPropertyGivenUp" (valChange)="DescriptionOfOtherPropertyGivenUp = $event;">
            </dst-custom-input>
          </div>
}
        </li>
        <br />
        <li>
          <div class="d-flex">
            <div class="col-md-10 pl-0">
              Adjusted basis of other property given up
            </div>
            <div class="col-md-2">
              <ap-field [title]="''" [fieldId]="'8'" [styleClass]="'number-field'" [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="AdjBasisOfOtherPropertyGivenUp"
                  [ngModelOptions]="{standalone: true}" (blur)="onCalculateAll()" [placeholder]="''"  aria-label="8" />
              </ap-field>
            </div>
          </div>
        </li>
        <br />

        <li>
          <div class="d-flex">
            <div class="col-md-10 pl-0">
              Gain or (loss) recognized on other property given up. Subtract line 13 from line 12. Report the gain or
              (loss) in the same manner as if the exchange had been a sale
            </div>
            <div class="col-md-2">
              <ap-field [title]="''" [fieldId]="'9'" [disabled]="true" [styleClass]="'total-field number-field'"
                [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="GainLossOnOtherPropertyGivenUp"
                  [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="9" />
              </ap-field>
            </div>
          </div>
        </li>
        <br />
        <li>
          <div class="d-flex">
            <div class="col-md-10 pl-0">
              Cash received, FMV of other property received, plus net liabilities assumed by other party, reduced (but
              not below zero) by any exchange expenses you incurred
            </div>
            <div class="col-md-2">
              <ap-field [title]="''" [fieldId]="'10'" [styleClass]="'number-field'" [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="CashFMVAndNetLiabRedByExpenses"
                  [ngModelOptions]="{standalone: true}" (blur)="onCalculateAll()"
                  [placeholder]="''"  aria-label="10" />
              </ap-field>
            </div>
          </div>
          @if (taxYear === '2023') {
<div class="d-flex mt-2 justify-content-between row">
            <div class="col-md-12">
              a. Description of other property received
            </div>
          </div>
}
          @if (taxYear === '2023') {
<div class="list-content a-textarea-box a-field-length-validation form-inlines">
            <dst-custom-input class="custom-input-100 p-0" [type]="'textarea'" [label]="''" [maxLength]="1000"
              [value]="DescriptionOfOtherPropertyRcvd" (valChange)="DescriptionOfOtherPropertyRcvd = $event;">
            </dst-custom-input>
          </div>
}
        </li>
        <br />
        <li>
          <div class="d-flex">
            <div class="col-md-10 pl-0">
              FMV of Like-Kind property you received
            </div>
            <div class="col-md-2">
              <ap-field [title]="''" [fieldId]="'11'" [styleClass]="'number-field'" [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="FMVOfLikeKindPropertyReceived"
                  [ngModelOptions]="{standalone: true}" (blur)="onCalculateAll()"
                  [placeholder]="''"  aria-label="11" />
              </ap-field>
            </div>
          </div>
        </li>
        <br />

        <li>
          <div class="d-flex">
            <div class="col-md-10 pl-0">
              Add lines 15 and 16
            </div>
            <div class="col-md-2">
              <ap-field [title]="''" [fieldId]="'12'" [disabled]="true" [styleClass]="'total-field number-field'"
                [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="AmountRealized" [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="12" />
              </ap-field>
            </div>
          </div>
        </li>
        <br />
        <li>
          <div class="d-flex">
            <div class="col-md-10 pl-0">
              Adjusted basis of Like-Kind property you gave up, net amounts paid to other party, plus any exchange
              expenses not used on line 15
            </div>
            <div class="col-md-2">
              <ap-field [title]="''" [fieldId]="'13'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="AdjBasisOfLikeKindPropGivenUp"
                  [ngModelOptions]="{standalone: true}" (blur)="onCalculateAll()" [placeholder]="''"  aria-label="13" />
              </ap-field>
            </div>
          </div>
        </li>
        <br />
        <li>
          <div class="d-flex">
            <div class="col-md-10 pl-0">
              Realized gain or (loss). subtract line 18 from line 17
            </div>
            <div class="col-md-2">
              <ap-field [title]="''" [fieldId]="'14'" [disabled]="true" [styleClass]="'total-field number-field'"
                [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="RealizedGainOrLoss" [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="14" />
              </ap-field>
            </div>
          </div>
        </li>
        <br />
        <li>
          <div class="d-flex">
            <div class="col-md-10 pl-0">
              Enter the smaller of line 15 or line 19, but not less than zero
            </div>
            <div class="col-md-2">
              <ap-field [title]="''" [fieldId]="'15'" [disabled]="true" [styleClass]="'total-field number-field'"
                [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="SmallerGainOrLoss" [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="15" />
              </ap-field>
            </div>
          </div>
        </li>
        <br />
        <li>
          <div class="d-flex">
            <div class="col-md-10 pl-0">
              Ordinary income under recapture rule. Enter here and on Form 4797, line 16
            </div>
            <div class="col-md-2">
              <ap-field [title]="''" [fieldId]="'16'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="OrdinaryIncmUndRecaptureRules"
                  [ngModelOptions]="{standalone: true}" (blur)="onCalculateAll()"
                  [placeholder]="''"  aria-label="16" />
              </ap-field>
            </div>
          </div>
        </li>
        <br />
        <li>
          <div class="d-flex">
            <div class="col-md-10 pl-0">
              Subtract line 21 from line 20. If zero or less, enter -0-. If more than zero, enter here and on Schedule D
              or Form 4797, unless the installment method applies
            </div>
            <div class="col-md-2">
              <ap-field [title]="''" [fieldId]="'17'" [disabled]="true" [styleClass]="'total-field number-field'"
                [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="SmallerGainLossLessOrdnryIncm"
                  [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="17" />
              </ap-field>
            </div>
          </div>
        </li>
        <br />
        <li>
          <div class="d-flex">
            <div class="col-md-10 pl-0">
              Recognized gain. Add lines 21 and 22
            </div>
            <div class="col-md-2">
              <ap-field [title]="''" [fieldId]="'18'" [disabled]="true" [styleClass]="'total-field number-field'"
                [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="RecognizedGain" [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="18" />
              </ap-field>
            </div>
          </div>
        </li>
        <br />
        <li>
          <div class="d-flex">
            <div class="col-md-10 pl-0">
              Deferred gain or (loss). Subtract line 23 from line 19
            </div>
            <div class="col-md-2">
              <ap-field [title]="''" [fieldId]="'19'" [disabled]="true" [styleClass]="'total-field number-field'"
                [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="DeferredGainOrLoss" [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="19" />
              </ap-field>
            </div>
          </div>
        </li>
        <br />
        <li>
          <div class="d-flex">
            <div class="col-md-10 pl-0">
              Basis of Like-Kind property received. Subtract line 15 from the sum of lines 18 and 23
            </div>
            <div class="col-md-2">
              <ap-field [title]="''" [fieldId]="'20'" [disabled]="true" [styleClass]="'total-field number-field'"
                [type]="'appkit-number'" [format]="''" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="BasisOfLikeKindPropertyRcvd"
                  [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="20" />
              </ap-field>
            </div>
          </div>
          @if (+taxYear >= 2023) {
<div class="d-flex mt-2">
            <div class="col-md-10 pl-0">
              a. Basis of Like-Kind section 1250 property recieved
            </div>
            <div class="col-md-2">
              <ap-field [title]="''" [fieldId]="'20'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="BasisOfLikeKindSect1250PropertyRcvd"
                  [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="20" />
              </ap-field>
            </div>
          </div>
}
          @if (+taxYear >= 2023) {
<div class="d-flex mt-2">
            <div class="col-md-10 pl-0">
              b. Basis of like-kind section 1245 property recieved
            </div>
            <div class="col-md-2">
              <ap-field [title]="''" [fieldId]="'20'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="BasisOfLikeKindSect1245PropertyRcvd"
                  [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="20" />
              </ap-field>
            </div>
          </div>
}
          @if (+taxYear >= 2023) {
<div class="d-flex mt-2">
            <div class="col-md-10 pl-0">
              c. Basis of like-kind intangible property recieved
            </div>
            <div class="col-md-2">
              <ap-field [title]="''" [fieldId]="'20'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'" [hideTitleOnInput]="true">
                    <input appkit-field [(ngModel)]="BasisOfLikeKindIntagblePropertyRcvd"
                  [ngModelOptions]="{standalone: true}" [placeholder]="''"  aria-label="20" />
              </ap-field>
            </div>
          </div>
}
        </li>
      </ol>
      <div class="leid-list d-flex" style="margin-top: 15px;">
        <span>LEIDs: </span>
        <div>
          @if (transferee) {
<span class="template-color-blue">{{ transferee.LEID }}</span>
}@if (transferor) {
<span> /
          </span>
}@if (transferor) {
<span class="template-color-blue">{{ transferor.LEID }}</span>
}
        </div>
      </div>
    </div>

  </div>
  <ng-template #template1>
    <div class="tooltip-inner ap-p-spacing-6 d-block a-min-width-340">
      <div class="a-h6 a-text-7d7 font-weight-normal text-left ap-mt-spacing-3">
        Reporting of multi-asset exchanges. If you transferred and received (a) more than one group of like-kind
        properties or (b) cash or other (not like-kind) property, do not complete lines 12 through 18 of Form 8824.
        Instead, attach your own statement showing how you figured the realized and recognized gain, and enter the
        correct amount on lines 19 through 25. Report any recognized gains on your Schedule D; Form 4797, Sales of
        Business Property; or Form 6252, Installment Sale Income, whichever applies.
      </div>
    </div>
  </ng-template>
</div>
